import { useEffect, useMemo } from "react";
import { useNewsletterCommon } from "@companion-core/shared/app/Components/NewsletterModal/hooks/useNewsletterCommon";
import { useNewsletterStore } from "@companion-core/shared/app/Store/newsletterStore";
import { APIMemberData } from "@companion-core/shared/app/Interfaces/API";
import { useMemberData } from "@companion-core/shared/app/Hooks/member";

export const useNewsletterReminder = () => {
  const { newsletterModule } = useNewsletterCommon();
  const { dismissDate, setIsOpen, isOpen } = useNewsletterStore();
  const { data: member } = useMemberData();
  const delay = useMemo(() => newsletterModule.delay || 2592000, [newsletterModule]);

  useEffect(() => {
    if (shouldRemindNewsletter(member) && newsletterModule.enabled) {
      setIsOpen(true);
    }
  }, [member, newsletterModule]);

  const shouldRemindNewsletter = (member?: APIMemberData): boolean => {
    return !!member && member.marketing_email !== "opt-in" && isRemindDelayExceeded();
  };

  const isRemindDelayExceeded = () =>
    dismissDate < 0 || new Date().getTime() >= dismissDate + delay * 1000;

  return { isOpen };
};
